import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_material_barcode_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { order_id: number }): 
  Promise<{ result: { BarcodeCount?: number, OrderLookupCode?: string, MaterialId?: number, Material?: { LookupCode?: string }, MaterialPackagingLookup?: { UpcCode?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { order_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { BarcodeCount?: number, OrderLookupCode?: string, MaterialId?: number, Material?: { LookupCode?: string }, MaterialPackagingLookup?: { UpcCode?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { order_id: number, $keys: { MaterialId?: number, Material?: { LookupCode?: string }, MaterialPackagingLookup?: { UpcCode?: string } }[] }): 
  Promise<{ result: { BarcodeCount?: number, OrderLookupCode?: string, MaterialId?: number, Material?: { LookupCode?: string }, MaterialPackagingLookup?: { UpcCode?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      order_id: number    }) {
        if(isNil($inParams.order_id)) {
          return true; 
        }
      return false;
    }
}
